import { StringToMuiIcon } from '@/components/StringToMuiIcon/StringToMuiIcon';
import { mainLayoutConstants } from '@/lib/main-layout-constants';
import type { navigation } from '@local/ui';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import {
  Box,
  Collapse,
  Divider,
  Icon,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import clsx from 'clsx';
import React from 'react';
import SideMenuItem from './SideMenuItem';

const { sidemenu } = mainLayoutConstants;

type Props = {
  section: navigation.ISection;
  expanded: boolean;
  currentHref?: string;
  menuManager: navigation.MenuManager;
  onClickSection: (e: React.MouseEvent) => void;
  onClickMenu: (menu: navigation.IMenu) => (e: React.MouseEvent) => void;
};

export default function SectionMenu(props: Props) {
  const {
    section,
    menuManager,
    onClickSection,
    expanded = false,
    currentHref,
    onClickMenu,
  } = props;

  const sectionActive = menuManager.isSectionPathMatched(section, currentHref);

  const [, setTick] = React.useState(0);

  const handleClickSection = (id: string) => () => {
    props.menuManager.toggleExpandSection(id);
    setTick((t) => t + 1); // 강제로 리렌더링
  };
  return (
    <>
      {/* Section 제목 */}
      <ListItemButton
        onClick={onClickSection}
        className={clsx('SectionMenu-root', {
          'SectionMenu-expanded': expanded,
          x_active: sectionActive,
        })}
        sx={{
          color: sidemenu.fgColor,

          '&:hover': {
            backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.15),
          },
          '& .SectionMenu-title': {
            fontWeight: 400,
            fontSize: sidemenu.fontSize,
            color: sidemenu.fgColor,
          },
          '& .MuiListItemIcon-root': {
            color: sidemenu.fgColor,
            minWidth: 30,
            maxWidth: 30,
          },
          '&.SectionMenu-expanded, &.x_active': {
            color: '#00f3e4',
            '& .SectionMenu-title': {
              color: '#00f3e4',
            },
            '& .MuiListItemIcon-root': {
              color: '#00f3e4',
            },
          },
        }}
      >
        {section.icon && (
          <ListItemIcon>
            <StringToMuiIcon iconName={section.icon + ''} />
          </ListItemIcon>
        )}
        <ListItemText primary={section.title} classes={{ primary: 'SectionMenu-title' }} />
        <Icon>{expanded ? <ExpandLess /> : <ExpandMore />}</Icon>
      </ListItemButton>

      {/* Section 내용 (재귀) */}
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <List disablePadding>
          {section.submenus?.map((menu, idx) => {
            if (menu.type === 'divider') {
              return <Divider key={menu.id} />;
            }

            if (menu.type === 'menu') {
              return (
                <Box key={menu.id} sx={{ ml: 3.5, borderLeft: '1px solid #E0E0E0' }}>
                  <SideMenuItem
                    title={menu.title}
                    icon={menu.icon}
                    active={menuManager.isMenuPathMatched(menu, currentHref)}
                    onClick={onClickMenu(menu)}
                  />
                </Box>
              );
            }

            if (menu.type === 'section') {
              const childSection = menu as navigation.ISection;
              return (
                <Box key={menu.id} sx={{ ml: 3.5, borderLeft: '1px solid #E0E0E0' }}>
                  <SectionMenu
                    section={childSection}
                    menuManager={menuManager}
                    currentHref={currentHref}
                    expanded={props.menuManager.isSectionExpanded(childSection.sectionId)}
                    onClickMenu={onClickMenu}
                    onClickSection={handleClickSection(childSection.sectionId as string)}
                  />
                </Box>
              );
            }

            return <div key={idx}>{JSON.stringify(menu)}</div>;
          })}
        </List>
      </Collapse>
    </>
  );
}
